
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js/auto';
import { ChartConfiguration } from 'chart.js';

import { sharedState } from '../../../../framework/state';

import { CustomerMakesReport } from '../../../../../common/application/model/report/CustomerMakesReport';
import { chartBackgroundColors, doughnutChartOptions, numberTooltipCallbacks } from '../../../service/report_service';

@Component
export default class VehicleMakeChart extends Vue {
    @Prop(Array) readonly rows!: CustomerMakesReport[];

    shared = sharedState;

    local = {
        co2Chart: undefined as Chart | undefined,
    };

    mounted() {
        setTimeout(() => {
            this.addVehicleCo2Chart();
        }, 200);
    }

    @Watch('rows')
    rowsChanged() {
        if (this.local.co2Chart && this.local.co2Chart.data && this.local.co2Chart.data.datasets) {
            this.local.co2Chart.data.datasets[0].data = this.chartData;
            this.local.co2Chart.data.labels = this.chartLabels;
            this.local.co2Chart.update();
        }
    }

    private addVehicleCo2Chart() {
        const canvasContext = (document.getElementById('vehicle-make-chart-canvas') as HTMLCanvasElement)!!;

        const chartConfiguration: ChartConfiguration = {
            type: 'doughnut',
            data: {
                labels: this.chartLabels,
                datasets: [
                    {
                        label: `${this.$t('label.co2Average')}`,
                        data: this.chartData,
                        backgroundColor: VehicleMakeChart.backgroundColors,
                        borderWidth: 0,
                        hoverBorderColor: VehicleMakeChart.backgroundColors[1],
                        hoverBorderWidth: 2,
                    },
                ],
            },
            options: {
                ...doughnutChartOptions,
                plugins: {
                    ...doughnutChartOptions.plugins,
                    legend: {
                        ...(doughnutChartOptions.plugins ? doughnutChartOptions.plugins.legend : {}),
                        display: this.chartLabels.length < 10,
                    },
                    tooltip: {
                        callbacks: { ...numberTooltipCallbacks },
                    },
                },
            },
        };

        this.local.co2Chart = new Chart(canvasContext, chartConfiguration);
    }

    private static get backgroundColors(): string[] {
        return chartBackgroundColors;
    }

    private get chartData(): number[] {
        return this.rows.map((makeRow) => (makeRow.co2average ? makeRow.co2average : 0));
    }

    private get chartLabels(): string[] {
        return this.rows.map((makeRow) => makeRow.make);
    }
}
